import type { OfferAddon } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'
import { useCalculateAddonOffers, useGetAddonOffers } from '../hooks/useOfferAddon'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'

export const carkulkaExtraOffersContext = createContext<IOffersContext<OfferAddon>>(defaults as any)

function CarkulkaExtraOffersProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      insuranceParamsId={props.insuranceParamsId}
      isContract={props.isContract}
      forceCalculation={props.forceCalculation}
      signalRCalcFinishedEventName='AddonCalcFinished'
      useGetOffers={useGetAddonOffers as any}
      useCalculateOffers={useCalculateAddonOffers}
      context={carkulkaExtraOffersContext as any}
    >
      {props.children}
    </OffersProvider >
  )
}

export default CarkulkaExtraOffersProvider


export const useCarkulkaExtraOffersContext = () => {
  const context = useContext(carkulkaExtraOffersContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useCarkulkaExtraOffersContext must be used within a CarkulkaExtraOffersProvider!')
  }

  return context
}